import { createPortal } from "react-dom";
import type { ChildrenProps } from "../types";

/** Props Interface */
interface PortalProps extends ChildrenProps {
	containerRef?: React.RefObject<HTMLElement | null>;
}

export function Portal({ children, containerRef }: PortalProps) {
	/** Guard */
	if (!document.body) return children;

	/** Render */
	return createPortal(children, containerRef?.current || document.body);
}
